import {
  bottomhero,
  textlogo,
  logowithclouds,
  farcloudshero,
  downarrow,
} from "../../../assets/images";
import React from "react";
import styles, { elements } from "../../../pages/styles";
import { Parallax } from "react-scroll-parallax";

const Hero = () => {
  return (
    <section
      id="home"
      className="flex flex-col justify-evenly -mt-4 white-primary"
    >
      <div className="flex flex-col sm:h-[40vh] h-[20vh] sm:min-h-[600px] min-h-[500px] items-center justify-start relative">
        <div className="absolute top-0 -z-20 w-full grainytop"></div>
        <div className="flex flex-col items-center justify-center sm:mt-0 pt-12">
          <Parallax
            speed={3}
            className="sm:min-w-[300px] min-w-[260px] w-[25%] flex justify-center"
          >
            <img src={logowithclouds} alt="Logo With Clouds" className="w-full" />
          </Parallax>
          <Parallax
            speed={6}
            className="sm:min-w-[240px] w-[160px] mt-[-5px] flex justify-center sm:mb-4 mb-2"
          >
            <img src={textlogo} alt="Tech Tails" className="w-full" />
          </Parallax>
          <Parallax speed={5} className="text-center mt-4">
            <h1 className={`${styles.heading2} px-4`}>
              Learn by your own curiosity and creating in a fun and engaging way
            </h1>
          </Parallax>
        </div>
        <Parallax
          speed={-0.5}
          className="absolute top-[19%] -z-20 min-w-[200px] w-full max-w-[90%]"
        >
          <img src={farcloudshero} alt="Tech Tails Clouds" className="w-full" />
        </Parallax>
        <Parallax
          speed={-6}
          className="min-w-[700px] -z-10 w-[80%] absolute sm:-bottom-2 -bottom-1"
        >
          <div id="about" className="flex justify-center">
            <img src={bottomhero} alt="Tech Tail Animals" className="w-full" />
          </div>
        </Parallax>
        <a
          href="#about"
          className="absolute w-[4%] bottom-16 min-w-[44px] flex justify-center mx-auto left-0 right-0 bg-whiteprimary hover:bg-pinkprimary rounded-full transition-colors duration-300"
        >
          <img src={downarrow} alt="Down Arrow" />
        </a>
      </div>
    </section>
  );
};

export default Hero;
